import React from 'react';
import bg from './../../Assets/img/bg.jpg'
import about from './../../Assets/img/about.jpg'
import {Helmet} from "react-helmet";

const About = () => {
    return (
        <>
            <Helmet>
                <title>About | Mega Dumpster Bin Rental - Best Company That Lets You Clean & Remove Trash & Rubbish</title>
            </Helmet>
            <section>
                <div className="container-fluid g-0">
                    <div className="page-banner">
                        <img src={bg} className="img-fluid" alt="About Us"/>
                        <div className="overly"/>
                        <div className="content">
                            <h1 className="display-1 text-white text-uppercase">ABOUT</h1>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row section-gap">
                        <div className="col-md-6">
                            <img src={about} className="img-thumbnail" alt="About US"/>
                        </div>
                        <div className="col-md-6">
                            <h6 className="text-center text-uppercase">WELCOME TO Mega Dumpster Bin Rental</h6>
                            <h5 className="text-center text-uppercase theme-color">About Mega Dumpster Bin Rental</h5>
                            <p className="lead py-5">Awesome! the best company that lets you clean and remove trash and
                                rubbish anywhere LA county you want.
                            </p>
                            <div className="row">
                                <div className="col-4"><h1 className="theme-color display-3">13</h1><p
                                    className="lead">YEARS OF EXPERIENCED</p></div>
                                <div className="col-4"><h1 className="theme-color display-3">2,342</h1><p
                                    className="lead">HAPPY CUSTOMERS</p></div>
                                <div className="col-4"><h1 className="theme-color display-3">30</h1><p
                                    className="lead">AWARD WINNING </p></div>
                            </div>
                        </div>
                    </div>
                    <div className="row section-gap justify-content-center">
                        <div className="col-md-12 text-start"><h4 className="text-uppercase mb-3">About Us</h4><p
                            className="lead">In fact, our employees live in the neighborhoods where we provide service, Call
                            us at (818) 773-7599, so you can count on us to take every opportunity to keep our communities
                            clean and safe for all of our families and businesses.</p></div>
                    </div>
                    <div className="section-gap"/>
                </div>
            </section>
        </>

    );
};

export default About;
